/** Sign-in routes and the return-to rule: only a same-origin path that is not itself a sign-in page is followed after sign-in. */
export const SIGN_IN_PATH = "/sign-in";
export const JOIN_PATH = "/join";
export const VERIFY_PATH = "/auth/verify";
const AUTH_PATHS: readonly string[] = [SIGN_IN_PATH, JOIN_PATH, VERIFY_PATH];
const PROBE_ORIGIN = "http://returnto.invalid";

/** `raw` as a path + query + hash when it is a safe in-app destination, else null ("//host", "/\\host" and absolute URLs are not). */
export function safeReturnTo(raw: string | null | undefined): string | null {
  if (raw === null || raw === undefined || !/^\/(?![/\\])/.test(raw)) return null;
  try {
    const url = new URL(raw, PROBE_ORIGIN);
    if (url.origin !== PROBE_ORIGIN || AUTH_PATHS.includes(url.pathname.replace(/(.)\/$/, "$1"))) return null;
    return url.pathname + url.search + url.hash;
  } catch { return null; }
}

/** A sign-in-page URL that remembers where to go afterwards. */
export const authHref = (path: string, returnTo: string | null): string =>
  returnTo === null ? path : `${path}?${new URLSearchParams({ returnTo }).toString()}`;

const SIGNED_IN_BEFORE = "bsim.signedInBefore";
/** Remembers on this browser that someone has signed in, so the sign-in page can greet a returning player and not a new one. */
export const rememberSignedIn = (): void => { try { localStorage.setItem(SIGNED_IN_BEFORE, "1"); } catch { /* a greeting only */ } };
export const hasSignedInBefore = (): boolean => { try { return localStorage.getItem(SIGNED_IN_BEFORE) !== null; } catch { return false; } };
